<script setup lang="ts">
import { computed } from 'vue'

import Button from '@fondof-ui/components/button/Button.vue'
import { spaceCaseVariantToCamelCaseVariant } from '@satch-ui/components/button/mapper'
import type { ButtonProps } from '@satch-ui/components/button/types'
import { buttonVariants } from '@satch-ui/components/button/variants'

const props = withDefaults(defineProps<ButtonProps>(), {
  variant: 'primary',
  size: 'default',
  textSize: 'base',
  padding: 'base',
  as: 'button',
})

const variant = computed(() => {
  return spaceCaseVariantToCamelCaseVariant(props.variant)
})
</script>

<template>
  <Button
    :class="[
      buttonVariants({
        variant,
        size: props.size,
        textSize: props.textSize,
        padding: props.padding,
        rounded: props.rounded,
        class: props.class,
      }),
      props.class ?? '',
    ]"
    :style="props.customColor ? { '--custom-color': props.customColor } : {}"
    :as="props.as"
    :as-child="props.asChild"
    :data-slot="props.size === 'icon' ? 'icon' : 'button'"
    :href="props.href"
    :disabled="props.disabled"
  >
    <slot />
  </Button>
</template>
